import styled from 'styled-components';

export const CardBody = styled.div`
    padding: var(--space-lg);
`;
